import * as React from 'react'

const styles = require('./styles.scss')

const IncentivesDisclaimer = () => (
  <p className={styles.disclaimerText}>
    *To receive the welcome bonus applicants must: (1) apply through an eligible referral link; (2) fund a loan balance
    through the Even Financial platform with a participating lending partner/platform that provides a pre-approved
    offer; (3) provide a valid email address to receive the bonus. Payment of any welcome bonus will occur via a credit
    redeemable for a digital gift card through TangoCard.com, sent to the email address provided by the applicant. Once
    conditions are met and the loan has been funded, eligible applicants will receive their welcome bonus within 6
    weeks. Offers not eligible for a bonus are determined at the sole discretion of Even Financial, Inc. and include but
    are not limited to special offers provided to applicants that do not receive any pre-approved lender offers. A $50
    welcome bonus will be paid for funded loan amounts between $1,000 and $10,000, and a $100 welcome bonus will be paid
    for funded loan amounts of $10,000 or more. Recipient is responsible for any applicable taxes and reporting
    associated with receiving the bonus offer. Even Financial reserves the right to change or terminate the offer at any
    time with or without notice.
  </p>
)

export default IncentivesDisclaimer
